import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const tooltipsTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'TOOLTIPS');


export const requestTooltips = () => {
    return {
        type: tooltipsTypes.REQUEST,
    };
};

export const receiveTooltips = (response) => {
    return {
        type: tooltipsTypes.RECEIVE,
        data: response,
    };
};

export const receiveTooltipsError = (response) => {
    return {
        type: tooltipsTypes.ERROR,
        error: response,
    };
};

export const fetchTooltips = () => {
    return dispatch => {
        let apiUrl = `/api/v1/tooltips/`

        dispatch(requestTooltips());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveTooltips(response));
            } catch (e) {
                dispatch(receiveTooltipsError(response));
            }
        })
        .catch(handleNetworkError);
    };
};